import { render, staticRenderFns } from "./SaleTypeCalendarHoverSettings.vue?vue&type=template&id=45d58d7a&scoped=true"
import script from "./SaleTypeCalendarHoverSettings.vue?vue&type=script&lang=ts"
export * from "./SaleTypeCalendarHoverSettings.vue?vue&type=script&lang=ts"
import style0 from "./SaleTypeCalendarHoverSettings.vue?vue&type=style&index=0&id=45d58d7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d58d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d58d7a')) {
      api.createRecord('45d58d7a', component.options)
    } else {
      api.reload('45d58d7a', component.options)
    }
    module.hot.accept("./SaleTypeCalendarHoverSettings.vue?vue&type=template&id=45d58d7a&scoped=true", function () {
      api.rerender('45d58d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeCalendarHoverSettings.vue"
export default component.exports